<template>
    <form :action="loginUrl" method="post" id="loginForm">
        <input type="hidden" name="callback_url" v-model="callback_url" />
        <input type="hidden" name="country" v-model="country" />
        <input type="hidden" name="language" v-model="language" />
        <input type="hidden" name="svc_code" v-model="svc_code" />
        <input type="hidden" name="service_division" v-model="service_division" />
        <div class="loading-wrap">
            <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
        </div>
    </form>
</template>

<script>

    import qs from "qs";

    export default {
        name: "LoginLink",
        data() {
            return {
                loginUrl: "",
                callback_url: "",
                country: "",
                language: "",
                svc_code: "",
                service_division: ""
            }
        },
        created() {
        },
        watch: {
        },
        computed: {
        },
        methods: {
            track () {
                console.log('@@@@ track:', this.$router.currentRoute.path);
                this.$ga.page(this.$router.currentRoute.path)
            }
        },
        mounted() {
            const vm = this;

            var loginPath = "";
            var loginYn = "";

            if(vm.$route.query.path != null && vm.$route.query.path != "") {
                loginPath = vm.$route.query.path;
            }
            if(vm.$route.query.loginYn != null && vm.$route.query.loginYn != "") {
                loginYn = vm.$route.query.loginYn;
            }

            var params = {
                cntryCode: _domainCntryCode,
                path: loginPath,
                loginYn: loginYn
            };

            this.$axios.post('/api/main/retrieveLoginInfo.ajax', qs.stringify(params)).then((result) => {
                vm.loginUrl = result.data.loginUrl;
                vm.callback_url = result.data.callback_url;
                vm.country = result.data.country;
                vm.language = result.data.language;
                vm.svc_code = result.data.svc_code;
                vm.service_division = result.data.service_division;

                vm.$nextTick(function() {
                    vm.$store.state.loginYn = "Y";
                    $("#loginForm").submit();
                });
            }).catch((err) => {
                alert(err);
            });
        }
    }
</script>

<style scoped>

</style>